import clsx from "clsx";
import { BookOpen } from "lucide-react";
import { useState } from "react";
import { ChevronDownIcon } from "@heroicons/react/24/solid";
import type { Heading } from "~/lib/toc";

type Props = {
  headings: Heading[];
};

export const TableOfContents: React.FC<Props> = ({ headings }) => {
  const [open, setOpen] = useState(false);
  const h2Headings = headings.filter((h) => h.level === 2);

  if (h2Headings.length < 2) return null;

  return (
    <nav
      aria-label="Spis treści"
      className="mb-8 overflow-hidden rounded-lg border-[1.5px] border-[#0C1F3F] bg-white"
    >
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className={clsx(
          "group flex w-full items-center justify-between border-b px-5 py-1.5 text-left shadow-sm transition-colors duration-300 ease-[cubic-bezier(0.22,1,0.36,1)]",
          open
            ? "border-[#0C1F3F] bg-[#0C1F3F] text-white"
            : "border-[#E5E7EB] bg-white text-[#0C1F3F] hover:border-[#00A87A] hover:bg-[#E8FAF4] hover:text-[#0C1F3F]"
        )}
        aria-expanded={open}
      >
        <div className="flex items-center gap-2">
          <BookOpen
            className={clsx(
              "h-4 w-4 flex-shrink-0 transition-colors duration-300 ease-[cubic-bezier(0.22,1,0.36,1)]",
              open ? "text-white" : "text-[#0C1F3F]"
            )}
          />
          <span className="font-semibold">Spis treści</span>
        </div>
        <ChevronDownIcon
          className={clsx(
            "h-5 w-5 flex-shrink-0 transition-all duration-300 ease-[cubic-bezier(0.22,1,0.36,1)]",
            open ? "rotate-180 text-white" : "text-[#0C1F3F]"
          )}
        />
      </button>

      <div
        className={clsx(
          "grid overflow-hidden transition-[grid-template-rows] duration-300 ease-[cubic-bezier(0.22,1,0.36,1)]",
          open ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
        )}
        aria-hidden={!open}
      >
        <div className="min-h-0 overflow-hidden">
          <ol className="space-y-1.5 bg-white px-5 py-4">
            {h2Headings.map((heading, i) => (
              <li key={i}>
                <a
                  href={`#${heading.id}`}
                  onClick={() => setOpen(false)}
                  className="text-sm font-medium leading-snug text-gray-900 transition hover:text-[#00A87A]"
                >
                  {heading.text}
                </a>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </nav>
  );
};
